import { Pipe, PipeTransform } from '@angular/core';
import { CmLocalizationService } from '../services';

/** @deprecated Use LocalizePipe from @cm/ui/localize */
@Pipe({
    name: 'cmLocalize',
    standalone: false
})
export class CmLocalizePipe implements PipeTransform {
	constructor(private localizationService: CmLocalizationService) {}

	transform(value: string, locKey: string): string {
		const localization = this.localizationService.findLocalization(locKey);
		return (localization || {}).value || value;
	}
}
